"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@services/piped-text-services/custom-metrics-menu-service");
var lodash_1 = __importDefault(require("lodash"));
(function (module) {
    'use strict';
    module.factory('prPipedTextMenuService', [
        'prPipedTextDateService',
        'prPipedTextSourceMenuService',
        'prActiveReport',
        '$filter',
        'prPipedTextService',
        'prOverrideTrigger',
        'pr.customMetricsMenuService',
        function (PipedTextDate, PipedTextSourceMenu, prActiveReport, $filter, PipedText, triggerOverrides, customMetricsMenuService) {
            function PipedTextMenu(quillEditor, editorLocator, widgetId) {
                this.date = new PipedTextDate();
                this.sourceMenu = new PipedTextSourceMenu();
                this.numericalSourceMenu = new PipedTextSourceMenu(true);
                this.pipedText = new PipedText(quillEditor, editorLocator, widgetId);
                return this;
            }
            PipedTextMenu.translate = $filter('translate');
            var proto = PipedTextMenu.prototype;
            var getHeader = function () {
                return {
                    label: PipedTextMenu.translate('PIPED_TEXT.PIPE_TEXT_FROM'),
                    header: true
                };
            };
            proto.getMenuItems = function () {
                var items = [
                    getHeader(),
                    {
                        label: PipedTextMenu.translate('PIPED_TEXT.DATE'),
                        submenu: {
                            items: this.date.getDateMenu()
                        }
                    },
                    {
                        label: PipedTextMenu.translate('PIPED_TEXT.REPORT'),
                        submenu: {
                            items: [{
                                    label: PipedTextMenu.translate('PIPED_TEXT.NAME'),
                                    value: {
                                        ptAttrs: {
                                            innerText: prActiveReport.getDescription(),
                                            type: 'activeReportMeta',
                                            attrName: 'activeReportName'
                                        }
                                    }
                                }]
                        }
                    },
                    {
                        label: PipedTextMenu.translate('SURVEY_DATA'),
                        submenu: {
                            items: this.sourceMenu.getSurveyDataMenu()
                        }
                    },
                    {
                        label: PipedTextMenu.translate('PIPED_TEXT.SOURCES'),
                        submenu: {
                            items: this.sourceMenu.getSourceMenu()
                        }
                    },
                ];
                items.push({
                    label: PipedTextMenu.translate('PR.CUSTOM_METRICS.CUSTOM_METRICS'),
                    submenu: {
                        items: customMetricsMenuService.getMenu()
                    }
                });
                return items;
            };
            proto.getPipedTextMenu = function () {
                var _this = this;
                var menu = {
                    type: 'pipedText',
                    items: this.getMenuItems(),
                    action: function ($value) {
                        _this.pipedText.insertMenuItem($value);
                    }
                };
                return triggerOverrides({
                    event: 'PIPED_TEXT_MENU',
                    data: menu
                }).then(function (menu) {
                    menu.items = lodash_1.default.filter(menu.items, function (item) {
                        if (lodash_1.default.isArray(lodash_1.default.get(item, 'submenu.items'))) {
                            return item.submenu.items.length;
                        }
                        return true;
                    });
                    return menu;
                });
            };
            // Uses the numerical source menu with shouldFilterNonNumericItems passed into the constructor.
            proto.getCustomMetricsMenuItems = function () {
                return [
                    getHeader(),
                    {
                        label: PipedTextMenu.translate('SURVEY_DATA'),
                        submenu: {
                            items: this.numericalSourceMenu.getSurveyDataMenu()
                        }
                    },
                    {
                        label: PipedTextMenu.translate('PIPED_TEXT.SOURCES'),
                        submenu: {
                            items: this.numericalSourceMenu.getSourceMenu()
                        }
                    }
                ];
            };
            return PipedTextMenu;
        }
    ]);
}(angular.module('qualtrics.pr')));
